module.exports = __webpack_public_path__ + "img/helper_sprite.a6fc83b3.svg";